// Skeleton placeholder for the heatmap during the initial fetch. Renders
// the 24×7 grid shape so the page doesn't shift when data lands.

import { cn } from "@shared/lib";

import { ACTIVITY_HEATMAP_STRINGS } from "../lib/strings";

export interface ActivityHeatmapSkeletonProps {
  loadingLabel?: string;
  className?: string;
}

export function ActivityHeatmapSkeleton({
  loadingLabel = ACTIVITY_HEATMAP_STRINGS.title,
  className,
}: ActivityHeatmapSkeletonProps) {
  return (
    <section
      aria-busy="true"
      aria-label={loadingLabel}
      className={cn("flex animate-pulse flex-col gap-2", className)}
    >
      <div className="h-4 w-32 rounded bg-muted" />
      <div className="h-3 w-56 rounded bg-muted" />
      <div className="flex flex-col gap-1 pt-2">
        {Array.from({ length: 7 }, (_, day) => (
          <div key={day} className="flex items-center gap-1">
            <div className="h-3 w-9 flex-none rounded bg-muted" />
            <div className="flex flex-1 gap-1">
              {Array.from({ length: 24 }, (_, hour) => (
                <div
                  key={hour}
                  className="aspect-square min-w-0 flex-1 rounded-sm bg-muted"
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
